import { combineReducers } from 'redux'
import { allEntriesReducerFactory } from './all-entries-reducer-factory.js'
import { byIdReducerFactory } from './by-id-reducer-factory.js'
import { entriesLoadedFactory } from './entries-loaded-factory.js'

const UNDEFINED_ACTION = 'not match anything'

export const entriesReducerFactory = (
  addEntryAction,
  removeAllEntriesAction = UNDEFINED_ACTION,
  removeEntryAction = UNDEFINED_ACTION,
  areEntriesLoadedAction = UNDEFINED_ACTION,
  unloadEntriesAction = UNDEFINED_ACTION,
) =>
  combineReducers({
    loaded: entriesLoadedFactory(areEntriesLoadedAction, unloadEntriesAction),
    byId: byIdReducerFactory(addEntryAction, removeAllEntriesAction, removeEntryAction),
    allIds: allEntriesReducerFactory(addEntryAction, removeAllEntriesAction, removeEntryAction),
  })
